// ================================================================================
// wp-block-slider.js
// スライダーのスクリプトファイル
// ================================================================================

import Swiper from 'swiper';
import { Thumbs, FreeMode, Autoplay, Navigation, Pagination } from 'swiper/modules';

window.addEventListener('load', () => {
	const mainEl = document.querySelector('.js-model-slider-swiper');
	const thumbEl = document.querySelector('.js-model-slider-swiper-thumb');
	if (!mainEl || !thumbEl) return;

	// 先にサムネ
	const swiperThumb = new Swiper(thumbEl, {
		modules: [Thumbs, FreeMode],
		slidesPerView: 'auto',
		spaceBetween: 8,
		watchSlidesProgress: true,
		freeMode: { enabled: true, sticky: false },
		slideToClickedSlide: true,

		// SP: 横スワイプ / PC: 中央固定（スワイプ無効）
		breakpoints: {
			782: {
				freeMode: { enabled: false },
				spaceBetween: 16,
				allowTouchMove: false,
				centeredSlides: true,
				centerInsufficientSlides: true,
			},
		},
	});

	const swiper = new Swiper(mainEl, {
		modules: [Thumbs, Autoplay, Navigation, Pagination],
		loop: true,
		slidesPerView: 1,
		speed: 1000,
		// autoplay: {
		// 	delay: 2500,
		// 	disableOnInteraction: false,
		// },
		thumbs: {
			swiper: swiperThumb,
		},
	});
});
